/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'

type Props = {
  className?: string
  svgIcon?: string
  titleClass?: string
  descriptionClass?: string
  iconClass?: string
  title?: string
  description?: string
}
const TilesWidget7 = (props: Props) => {
  const {className, svgIcon, titleClass, descriptionClass, iconClass, title, description} = props
  return (
    <div className={clsx('card', className)}>
      <div className='card-body d-flex flex-column justify-content-between' style={{backgroundImage:`url(${toAbsoluteUrl('/media/circle.png')})`,backgroundPosition:'top right',backgroundRepeat:'no-repeat',backgroundSize:'75px'}}>
        <KTIcon iconName={svgIcon || ''} className={clsx(iconClass, 'fs-2hx ms-n1 flex-grow-1')} />
        <div className='d-flex justify-content-between align-items-center'>
          <div className={clsx(descriptionClass, 'fw-semibold fs-4 mt-10')}>{description}</div>
          <div className={clsx(titleClass, 'fw-bold mt-10')} style={{fontSize:'40px',color:'#5A98B4'}}>{title}</div>
        </div>
      </div>
    </div>
  )
}

export {TilesWidget7}
